<template>
  <div class="floating-buttons">
    <div class="message-btn" v-if="$store.state.isLoggedIn && $store.state.isRole !=0">
      <img src="@/assets/homepage/消息.png" alt="Message" class="button-image pointer" @click="goToMessages">
      <span class="notification-dot">{{ unreadMessages > 99 ? '99+' : unreadMessages }}</span>
    </div>
    <!-- 返回顶部按钮 -->
    <div class="scroll-to-top-btn">
      <img src="@/assets/homepage/返回顶部.png" alt="Return to Top" class="button-image pointer" @click="scrollTop">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      counts: 0,
    };
  },
  computed: {
    unreadMessages() {
      return this.$store.state.unreadMessages;
    }
  },
  created() {
    this.$store.dispatch('fetchUnreadMessages');
  },
  methods: {
    // 返回顶部方法
    scrollTop() {
      this.$emit("scrollToTop");
    },
    // 跳转到消息页面
    goToMessages() {
      this.$router.push('/myAccount/messages');
    }
  }
}
</script>

<style scoped>
.floating-buttons {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* 图片样式 */
.button-image {
  width: 60px;  /* 可以根据需要调整大小 */
  height: 60px;
  object-fit: cover;
}

/* 消息按钮上的红色通知圆点 */
.notification-dot {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 20px;
  height: 20px;
  padding: 3px;
  background-color: red;
  color: white;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/FloatingButton.vue